import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";

import { setAccount, setStatus } from "@/store/authSlice";
import { useAppDispatch } from "@/store/hooks";
import { resetRoleState } from "@/store/roleSlice";

export const useGlobalAuthSync = () => {
  const { instance } = useMsal();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleStorage = (event: StorageEvent) => {
      // LOGOUT SYNC
      if (event.key === "msal-logout") {
        // console.log("[AuthSync] Logout detected in another tab");

        // Clear MSAL
        instance.setActiveAccount(null);

        // Clear Redux / app state
        dispatch(resetRoleState());
        dispatch(setAccount(null));
        dispatch(setStatus("signedOut"));

        // Force redirect to origin
        window.location.href = window.location.origin;
      }
    };

    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener("storage", handleStorage);
    };
  }, [instance, dispatch]);
};
